export const MAX_Z_INDEX = 1000000;

/**
 * A stable paint order shared by the editor and file exporters. zIndex ranks all
 * shapes and connections; containment adds one dependency: a parent is painted
 * before its children. Selecting an object never changes this order.
 */
export function getPaintOrder(state) {
  const nodes = state.nodes || [], edges = state.edges || [];
  const nodeMap = new Map(nodes.map(node => [node.id, node]));
  const depths = new Map();
  function depth(node, ancestors = new Set()) {
    if (depths.has(node.id)) return depths.get(node.id);
    if (ancestors.has(node.id)) throw new Error('图层包含循环父子关系。');
    ancestors.add(node.id);
    const parent = nodeMap.get(node.parentId);
    const result = parent ? depth(parent, ancestors) + 1 : 0;
    depths.set(node.id, result); return result;
  }
  const entries = nodes.map((item, index) => ({ kind: 'node', item, ordinal: index, z: item.zIndex === undefined ? item.type === 'container' ? depth(item) : 100 + depth(item) : item.zIndex }))
    .concat(edges.map((item, index) => ({ kind: 'edge', item, ordinal: nodes.length + index, z: item.zIndex === undefined ? 80 : item.zIndex })));
  if (entries.some(entry => !Number.isInteger(entry.z) || Math.abs(entry.z) > MAX_Z_INDEX)) throw new Error('图层顺序必须是范围内的整数。');
  const children = new Map(), available = [];
  entries.forEach(entry => {
    if (entry.kind === 'node' && nodeMap.has(entry.item.parentId)) {
      const siblings = children.get(entry.item.parentId) || [];
      siblings.push(entry); children.set(entry.item.parentId, siblings);
    } else available.push(entry);
  });
  const compare = (a, b) => a.z - b.z || a.ordinal - b.ordinal;
  available.sort(compare);
  function insert(entry) {
    let low = 0, high = available.length;
    while (low < high) {
      const middle = (low + high) >> 1;
      if (compare(available[middle], entry) <= 0) low = middle + 1;
      else high = middle;
    }
    available.splice(low, 0, entry);
  }
  const result = [];
  while (available.length) {
    const entry = available.shift();
    result.push({ kind: entry.kind, item: entry.item });
    if (entry.kind === 'node') (children.get(entry.item.id) || []).forEach(insert);
  }
  if (result.length !== entries.length) throw new Error('图层包含循环父子关系。');
  return result;
}
